import { get, post } from '@aiptyg/api-client';
import type {
  BulkDisableWithdrawalTargetRiskUsersResultDTO,
  WithdrawalTargetRiskListResponseDTO,
  WithdrawalTargetRiskUsersResponseDTO,
} from '../types/withdrawal-target-risk.types';

export function listWithdrawalTargetRisk(params: {
  page: number;
  pageSize: number;
  targetType: string;
  keyword: string;
  userId: string;
  minDistinctUsers: string;
}): Promise<WithdrawalTargetRiskListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.targetType) qs.set('target_type', params.targetType);
  if (params.keyword.trim()) qs.set('keyword', params.keyword.trim());
  if (params.userId.trim()) qs.set('user_id', params.userId.trim());
  if (params.minDistinctUsers.trim()) qs.set('min_distinct_users', params.minDistinctUsers.trim());
  return get<WithdrawalTargetRiskListResponseDTO>(`/v1/admin/withdrawal-target-risk?${qs.toString()}`);
}

export function listWithdrawalTargetRiskUsers(params: {
  targetHash: string;
  page: number;
  pageSize: number;
}): Promise<WithdrawalTargetRiskUsersResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  return get<WithdrawalTargetRiskUsersResponseDTO>(
    `/v1/admin/withdrawal-target-risk/${encodeURIComponent(params.targetHash)}/users?${qs.toString()}`,
  );
}

export function bulkDisableWithdrawalTargetRiskUsers(params: {
  targetHash: string;
  userIds: number[];
  reason: string;
}): Promise<BulkDisableWithdrawalTargetRiskUsersResultDTO> {
  return post<BulkDisableWithdrawalTargetRiskUsersResultDTO>(
    '/v1/admin/withdrawal-target-risk/bulk-disable-users',
    {
      target_hash: params.targetHash,
      user_ids: params.userIds,
      reason: params.reason,
    },
  );
}
